import FooterLink from './FooterLinks';
import styles from './Footer.module.scss';
import menus from './menus';
import Corporate from './Corporate/Corporate';
import Social from './Social/Social';
/**
 * Render Footer
 *
 * @return {Element} Footer component
 */
export default function Footer() {
  return (
    <footer className={styles.cnnFooter}>
      <div className={styles.cnnFooter__footerInner}>
        {menus &&
          menus.map((item) => {
            return (
              <div key={item.title} className={styles.cnnFooter__link}>
                <a rel="noreferrer" href={item.url} target="_blank">
                  {item.title}
                </a>
                <FooterLink item={item} />
              </div>
            );
          })}
        <Social />
        <Corporate />
      </div>
    </footer>
  );
}
